import React from 'react';
import {useAtom} from "jotai";
import {
  activeFiltersAtom,
  currentFilterStepAtom,
  filteredNodesAtom,
  filterReverseAtom,
  finishedAtom
} from "../../atoms/atoms";
import {TermLight} from "../Terms/interfaces";
import {useResetAtom} from "jotai/utils";
import {motion, AnimatePresence} from "framer-motion";
import styled from "styled-components/macro";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-light-svg-icons'
import TermColorist from "../Terms/TermColorist";
import colors from "../../styles/variables/colors";
import {ActiveFilterInterface} from "./interfaces";
import ReactGA from 'react-ga4';

type ActiveFilterComponent = (props: ActiveFilterInterface) => JSX.Element;

const animatedBubbleStart = {
  maxWidth: 0,
  opacity: 0,
  transform: "translateX(-40px)"
}
const animatedBubbleEnd = {
  transform: ["translateX(-40px)","translateX(0px)"], maxWidth: ["0%","100%"], opacity: [0,1],
}
const fixedBubble = {
  maxWidth: "100%",
  opacity: 1
}

export const FilterWrapper = styled.div`
  padding: 15px 15px 15px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  // @media (min-width: 1024px) {
  //     padding: 15px 15px 15px;
  // }
`;

export const BottomFilterBubble = styled(motion.div)`
  display: inline-flex;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 13px;
  align-items: center;
  font-family: "Helvetica Now Micro W01 Medium", sans-serif;
  letter-spacing: -0.02em;
  cursor: default;

  span {
    font-family: "Helvetica Now Micro W01 Medium", sans-serif;
    line-height: 19px;
  }
`;

export const BubbleReset = styled.button`
  border-radius: 50%;
  background-color: ${colors.white.base};
  line-height: 16px;
  font-size: 16px;
  width: 20px;
  height: 20px;
  margin: 1px -5px 0 5px;
  cursor: pointer;

  svg {
    color: ${colors.slate.base};
    vertical-align: 0;
  }

  &:hover{
    background-color: ${colors.slate["80"]};
    svg {
      color: ${colors.white.base};
    }
  }
`;

const ActiveFilter: ActiveFilterComponent = ({resultPage = false}) => {
  const [, setFinished] = useAtom(finishedAtom);
  const [filterStep, setFilterStep] = useAtom(currentFilterStepAtom);
  const [activeFilters, setActiveFilters] = useAtom(activeFiltersAtom);
  const [, setFilterReverse] = useAtom(filterReverseAtom);
  const resetFilteredNodes = useResetAtom(filteredNodesAtom);

  const RemoveEntry = () => {
    setFinished(false);
    resetFilteredNodes();
    if (filterStep > 0) {
      const lastTerm = activeFilters.pop()
      setFilterReverse(true)
      setActiveFilters(activeFilters)
      setFilterStep(filterStep - 1);
      ReactGA.event({
        category: 'ProductFinder',
        action: 'Remove Filter',
        label: lastTerm?.title
      });
    }
  }

  const getKey = (item:TermLight, counter:number) => {
    return `term:${item.id}_step:${counter}_active_bubble${resultPage && '_result'}`
  }

  const FilterActive: Function = (): JSX.Element[] => {
    return activeFilters.map((item:TermLight, counter) => {
      const animate = (counter + 1)  === activeFilters.length;
      const currentColor = TermColorist({currentFilterStep: counter});
      const appendReset = (activeFilters.length - 1) === counter;
      return (
        <BottomFilterBubble
          style={{ backgroundColor: currentColor.background, color: currentColor.text }}
          initial={animate ? animatedBubbleStart : fixedBubble}
          animate={animate ? animatedBubbleEnd : fixedBubble}
          key={getKey(item, counter)}
          transition={{ ease: "anticipate", duration: 0.4 }}
          className={animate ? 'last' : ''}
        >
          <span style={{ color: currentColor.text }}>{item.title}</span>
          {appendReset &&
            <BubbleReset onClick={RemoveEntry}>
              <FontAwesomeIcon icon={faTimes} />
            </BubbleReset>
          }
        </BottomFilterBubble>
      )
    });
  };


  if (activeFilters.length === 0) {
    return <></>
  }

  return (
    <FilterWrapper>
      <AnimatePresence>
        <FilterActive />
      </AnimatePresence>
    </FilterWrapper>
  )
}

export default ActiveFilter;
